import DiscoverButton from "./DiscoverButton";
import { Center } from "@chakra-ui/react";

export default function CardDelisted() {
  return (
    <>
      <Center>
        <p>Card doesn{"'"}t exist or has been delisted</p>
      </Center>
      <Center>
        <DiscoverButton />
      </Center>
    </>
  );
}
